function selectOptionByDataI(dataIValue) {

  // Get the select element
  const selectElement = document.getElementById('fieldname1_1');
        
  // Iterate through the options
  for (let i = 0; i < selectElement.options.length; i++) {
    const option = selectElement.options[i];
            
    // Check if the data-i attribute matches the desired value
    if (option.getAttribute('vt') === dataIValue) {
      console.log('match!');
      console.log(option.getAttribute('data-i'));

      // Set the selected option
      selectElement.selectedIndex = i;
      break;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const defaultVloer = document.querySelector('#default-vloersoort');
    console.log(defaultVloer);
    if (defaultVloer) {
      const value = defaultVloer.getAttribute('data-name');
      console.log(value);
      selectOptionByDataI(value); // This will select the option with data-i="1"
    }
  }, 500);

});

document.addEventListener('DOMContentLoaded', () => {
  const mainImageFigure = document.querySelector('.main-image');
  const mainImage = mainImageFigure.querySelector('img');
  const mainCaption = mainImageFigure.querySelector('figcaption');
  const thumbnails = document.querySelectorAll('.gallery img');
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const closeLightbox = document.querySelector('.close');

  // Lightbox functionality
  //   mainImageFigure.addEventListener('click', () => {
  //     console.log('CIC:)');
  //     lightbox.style.display = 'block';
  //     lightboxImg.src = mainImage.src;
  //   });

  closeLightbox.addEventListener('click', () => {
    lightbox.style.display = 'none';
  });

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      lightbox.style.display = 'none';
    }
  });

  // Thumbnail click functionality
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      console.log(thumbnail.src);
      console.log(mainImage.src);
      mainImage.src = thumbnail.src;
      mainImage.srcset = thumbnail.srcset;

      mainCaption.textContent = thumbnail.nextElementSibling.textContent;
    });
  });
});

document.addEventListener('wpcf7mailsent', function(event) {
  setTimeout(() => {
    window.location = '/bedankt/';
  }, 3000); // Wait for 3 seconds to redirect.
}, false);
